import { ORDER_STATUS } from 'constants/all';

import type { OrderListTabId } from 'modules/orders/listPage/types';

export const TAB_ID_TO_EMPTY_TEXT_MAP: Record<
  OrderListTabId,
  {
    headline: string;
  }
> = {
  [ORDER_STATUS.ALL]: {
    headline: 'No orders',
  },
  [ORDER_STATUS.PENDING]: {
    headline: 'No pending orders',
  },
  [ORDER_STATUS.CONFIRMED]: {
    headline: 'No confirmed orders',
  },
  [ORDER_STATUS.ON_HOLD]: {
    headline: 'No on hold orders',
  },
  [ORDER_STATUS.IN_PROCESS]: {
    headline: 'No in process orders',
  },
  [ORDER_STATUS.COMPLETED]: {
    headline: 'No completed orders',
  },
  [ORDER_STATUS.CANCELLED]: {
    headline: 'No cancelled orders',
  },
};
